import { Alert, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { drawerWidth } from 'store/constant';
import useImpersonation from 'hooks/useImpersonation';

const ImpersonationBanner = () => {
  const { impersonating, impersonatorUsername, username, stopImpersonate } = useImpersonation();
  const leftDrawerOpened = useSelector((state) => state.customization.opened);

  if (!impersonating) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      variant="filled"
      sx={(theme) => ({
        borderRadius: 0,
        width: '100%',
        alignItems: 'center',
        '& .MuiAlert-message': { flex: 1 },
        // 桌面端向右偏移一个侧边栏宽度，避免横幅左侧被侧边栏遮挡
        [theme.breakpoints.up('md')]: {
          ml: leftDrawerOpened ? `${drawerWidth}px` : 0,
          width: leftDrawerOpened ? `calc(100% - ${drawerWidth}px)` : '100%',
          transition: theme.transitions.create(['margin', 'width'])
        }
      })}
      action={
        <Button color="inherit" size="small" variant="outlined" onClick={stopImpersonate} sx={{ borderColor: 'rgba(255,255,255,0.5)' }}>
          退出模拟
        </Button>
      }
    >
      管理员 {impersonatorUsername} 正在以用户 {username} 的身份查看系统
    </Alert>
  );
};

export default ImpersonationBanner;
